import { DocumentTypeEntity } from '../../distribution/models';

export class DataGroupDistributionObject {
    AccessTrackingDocuments: boolean;
    DistributionObject: DocumentTypeEntity;
}
